<template>
  <a class="nav_link" :class="{'active': active}" @click="toggleMenu">
    <svg v-if="icon" class="nav_icon">
      <use :xlink:href="icon"></use>
    </svg>
    <div class="label">
      <span>{{ label }}</span>
      <svg class="nav_caret" :style="show ? 'transform: rotate(90deg)' : ''">
        <use xlink:href="#caret"></use>
      </svg>
    </div>
  </a>
  <div v-show="show" class="nav_group">
    <ul class="sidebar_list">
      <slot/>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SidebarSubMenu",

  props: {
    label: {
      type: String,
      required: true,
    },

    icon: {
      type: String,
      default: ''
    },

    active: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      show: this.active,
    }
  },

  methods: {
    toggleMenu() {
      this.show = !this.show;
    }
  }
}
</script>
